// ** React Imports
import {Fragment, SyntheticEvent, useState} from 'react'

// ** MUI Imports
import Badge from '@mui/material/Badge'
import IconButton from '@mui/material/IconButton'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Third Party Components
// ** Type Imports
import {Settings} from 'src/@core/context/settingsContext'

// ** Custom Components Imports
import NotificacionMenu from "./components/NotificationMenu";
import {useNotificaciones} from "../../../../pages/notifications/hooks/useNotificaciones";

const MAX_NOTIFICACIONES = 6

interface Props {
    settings: Settings
}

const NotificationDropdown = (props: Props) => {
    // ** Props
    const {settings} = props

    // ** States
    const [anchorEl, setAnchorEl] = useState<(EventTarget & Element) | null>(null)

    // ** Vars
    const {direction} = settings

    const {notificaciones} = useNotificaciones()

    const handleDropdownOpen = (event: SyntheticEvent) => {
        setAnchorEl(event.currentTarget)
    }

    const handleDropdownClose = () => {
        setAnchorEl(null)
    }

    return (
        <Fragment>
            <IconButton color='inherit' aria-haspopup='true' onClick={handleDropdownOpen}
                        aria-controls='customized-menu'>
                <Badge
                    color='error'
                    variant='dot'
                    invisible={!notificaciones.length}
                    sx={{
                        '& .MuiBadge-badge': {
                            top: 4,
                            right: 4,
                            boxShadow: theme => `0 0 0 2px ${theme.palette.background.paper}`
                        }
                    }}
                >
                    <Icon icon='mdi:bell-outline'/>
                </Badge>
            </IconButton>
            <NotificacionMenu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleDropdownClose}
                anchorOrigin={{vertical: 'bottom', horizontal: direction === 'ltr' ? 'right' : 'left'}}
                transformOrigin={{vertical: 'top', horizontal: direction === 'ltr' ? 'right' : 'left'}}
                notificaciones={notificaciones.slice(0, MAX_NOTIFICACIONES)}
            />

        </Fragment>
    )
}

export default NotificationDropdown
